import { Component } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styles: [
        `
        .home-container{
            @media (min-width: 768px) {
            max-width: 1140px;
            }
        }
        `,
    ],
})
export class HomeComponent {
    constructor() {}
}
